export const GET_CUSTOMER_PAYMENTS_REQUESTED = 'GET_CUSTOMER_PAYMENTS_REQUESTED'
export const GET_CUSTOMER_PAYMENTS_SUCCEEDED = 'GET_CUSTOMER_PAYMENTS_SUCCEEDED'
export const GET_CUSTOMER_PAYMENTS_FAILED = 'GET_CUSTOMER_PAYMENTS_FAILED'

export const SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED = 'SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED'
export const SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED = 'SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED'
export const SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED = 'SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED'
